import request from '@/utils/request'

export function feachSaleOrderList(data) { // 获取列表
  return request({
    url: '/saleOrder/list',
    method: 'POST',
    data
  })
}

export function postSaleOrderReceipt(data) { // 已配送收款
  return request({
    url: '/saleOrder/receipt/h5',
    method: 'POST',
    data
  })
}

